
// -- React Libraries
import React from 'react';
import Button from '../../../components/uielements/button';

// -- Styles
import StyleWrapper from "./Wrapper";

// -- Resources
import GreenLogo from '../../../image/gogochart_greenlogo.png';

export default class LoginButton extends React.Component {
    render() {
        return (
            <StyleWrapper>
                <Button onClick={ () => this.props.history.push(`${'/home'}`) } className="sign-in">
                    {this.props.children}
                </Button>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/components/Headers/LoginButton/index.js